/**
 * ROI back-in-stock capture (2026-09-09).
 *
 * One dialog per page (snippets/roi-bis-form.liquid), opened from:
 *  - the PDP button (blocks/roi-back-in-stock.liquid), which this script
 *    keeps in sync with Horizon's variant picker by swapping the block's
 *    innerHTML from the page HTML the picker already fetches;
 *  - the pack picker (assets/roi-pack-pdp.js) via window.roiBisOpen().
 *
 * Capture = POST of Shopify's native customer form. Success is detected
 * by the redirect landing on `customer_posted=true`. If Shopify answers
 * with its bot challenge (403 / /challenge), the form is submitted the
 * classic way so the challenge page can finish the post and bounce back
 * to return_to (?bis=1&customer_posted=true → we reopen in "done").
 *
 * Everything is document-delegated on purpose: sections and blocks get
 * re-rendered via innerHTML/morph, inline scripts would never re-run.
 */
(function () {
  'use strict';
  if (window.__roiBis) return;
  window.__roiBis = true;

  var UTM_KEY = 'roi_utm';
  var LAST_KEY = 'roi_bis_last';
  var DONE_KEY = 'roi_bis_done';

  function store(key, val) {
    try {
      if (val == null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
  }
  function read(key, fallback) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  // First-touch UTM memo (theme.liquid writes the same key site-wide).
  (function captureUtm() {
    try {
      var q = new URLSearchParams(location.search);
      var o = {};
      var has = false;
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = q.get(k);
        if (v) {
          o[k] = v.slice(0, 120);
          has = true;
        }
      });
      if (has && !sessionStorage.getItem(UTM_KEY)) sessionStorage.setItem(UTM_KEY, JSON.stringify(o));
    } catch (e) {}
  })();

  function dialog() {
    return document.querySelector('dialog[data-roi-bis-dialog]');
  }

  function cleanTag(s) {
    return String(s || '')
      .replace(/,/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 200);
  }

  // "Florida Sportsman Tee | Olive + Black | Unisex Short-Sleeve Comfort Tee"
  // → "Florida Sportsman Tee Olive + Black"; "Raised On It | America 250 |
  // All American Summer Tee" → "America 250 All American Summer Tee".
  function shortTitle(title) {
    var segs = String(title || '')
      .split('|')
      .map(function (s) {
        return s.trim();
      })
      .filter(function (s) {
        return s && !/^raised on it$/i.test(s);
      });
    if (!segs.length) return String(title || '').trim();
    return segs.slice(0, 2).join(' ');
  }

  function today() {
    var d = new Date();
    var m = String(d.getMonth() + 1);
    var day = String(d.getDate());
    return d.getFullYear() + '-' + (m.length < 2 ? '0' + m : m) + '-' + (day.length < 2 ? '0' + day : day);
  }

  var current = {};

  function setState(dlg, state, msg) {
    var wrap = dlg.querySelector('[data-roi-bis-formwrap]');
    var done = dlg.querySelector('[data-roi-bis-done]');
    var err = dlg.querySelector('[data-roi-bis-error]');
    if (wrap) wrap.hidden = state === 'done';
    if (done) done.hidden = state !== 'done';
    if (err) {
      err.hidden = !msg;
      err.textContent = msg || '';
    }
  }

  function itemLabel(p) {
    var t = shortTitle(p.productTitle);
    return [t, p.variantTitle].filter(Boolean).join(' · ');
  }

  /**
   * Shopify's storefront-form captcha bootstrap only binds a /contact
   * customer form after a focusin/change event bubbles from one of its
   * fields; an UNBOUND form's submit is swallowed (preventDefault, then
   * nothing). Real typing binds it, autofill/password managers may not —
   * so arm it explicitly when the dialog opens via Shopify's public hook,
   * with a synthetic focusin as the fallback (live finding 2026-09-09).
   */
  function armCaptcha(dlg) {
    var form = dlg.querySelector('form.roi-bis__form');
    if (!form || form.dataset.cptcha) return;
    try {
      var sc = window.Shopify && window.Shopify.captcha;
      if (sc && typeof sc.protect === 'function') {
        sc.protect(form);
        return;
      }
    } catch (e) {}
    var email = form.querySelector('input[name="contact[email]"]');
    if (email) {
      try {
        email.dispatchEvent(new Event('focusin', { bubbles: true }));
      } catch (e2) {}
    }
  }

  function open(payload, state) {
    var dlg = dialog();
    if (!dlg) return false;
    current = payload || {};
    // 2026-09-12: demand-signal event for the ads read (memo 9/12 12:00 #3).
    if (state !== 'done') {
      try {
        if (typeof window.roiTrack === 'function') {
          window.roiTrack('notify_me_opened', {
            variant_id: current.variantId,
            source: current.source || 'pdp',
            product: current.productTitle,
            variant: current.variantTitle,
          });
        }
      } catch (e) {}
    }
    armCaptcha(dlg);
    var item = dlg.querySelector('[data-roi-bis-item]');
    if (item) item.textContent = itemLabel(current);
    setState(dlg, state || 'form');
    if (!dlg.open) {
      try {
        dlg.showModal();
      } catch (e) {
        dlg.setAttribute('open', '');
      }
    }
    if (state !== 'done') {
      var email = dlg.querySelector('input[name="contact[email]"]');
      if (email) setTimeout(function () { email.focus(); }, 60);
    }
    return true;
  }

  function close() {
    var dlg = dialog();
    if (dlg && dlg.open) dlg.close();
  }

  function buildTags(form) {
    var utm = read(UTM_KEY, {});
    var tags = ['BIS'];
    if (current.variantId) tags.push('BIS-V:' + cleanTag(current.variantId));
    var label = cleanTag(shortTitle(current.productTitle));
    if (current.variantTitle) label += ' | ' + cleanTag(current.variantTitle);
    if (label) tags.push('BIS:' + label);
    tags.push('BIS-SRC:' + cleanTag(current.source || 'pdp'));
    tags.push('BIS-D:' + today());
    if (utm.utm_campaign) tags.push('BIS-UTM:' + cleanTag(utm.utm_campaign));
    if (utm.utm_content) tags.push('BIS-UTMC:' + cleanTag(utm.utm_content));
    var toggle = form.querySelector('[data-roi-bis-sms-toggle]');
    var phone = form.querySelector('[data-roi-bis-phone]');
    if (toggle && toggle.checked && phone && phone.value.trim()) tags.push('BIS-SMS:' + cleanTag(phone.value));
    return tags.join(',');
  }

  function markDone(variantId) {
    var done = read(DONE_KEY, []);
    if (variantId && done.indexOf(String(variantId)) < 0) {
      done.push(String(variantId));
      store(DONE_KEY, done);
    }
    paintDone();
  }

  function paintDone() {
    var done = read(DONE_KEY, []);
    if (!done.length) return;
    document.querySelectorAll('[data-roi-bis-open]').forEach(function (btn) {
      if (done.indexOf(String(btn.getAttribute('data-variant-id'))) > -1) {
        btn.classList.add('is-done');
        btn.textContent = "You're on the list";
      }
    });
  }

  /**
   * The form posts the classic way on purpose. The store runs Shopify's
   * storefront-form spam protection: Shopify's own script (injected via
   * content_for_header) listens for the real submit event, fetches the
   * captcha token and then submits — a programmatic fetch/submit() gets
   * "400 Missing CAPTCHA token" (verified on the dev theme 2026-09-09).
   * So here we only stamp the tags + return_to and let the submit run;
   * Shopify bounces back to return_to (?bis=1 → customer_posted=true)
   * and resume() reopens the dialog in the done state.
   */
  function onSubmit(e) {
    var form = e.target && e.target.closest ? e.target.closest('form.roi-bis__form') : null;
    if (!form) return;
    var tagsInput = form.querySelector('[data-roi-bis-tags]');
    if (tagsInput) tagsInput.value = buildTags(form);
    var ret = form.querySelector('[data-roi-bis-return]');
    var retUrl = location.pathname + (location.search ? location.search + '&' : '?') + 'bis=1';
    if (ret) ret.value = retUrl;
    store(LAST_KEY, current);
    var btn = form.querySelector('[data-roi-bis-submit]');
    if (btn) {
      // Relabel only. Never disable: Shopify's captcha binding submits
      // asynchronously after the token arrives, and a disabled control in
      // the form can stall that (dev-theme finding 2026-09-09).
      setTimeout(function () {
        btn.textContent = 'One sec…';
      }, 0);
    }
  }

  // PDP: keep the block in step with the variant picker.
  function onProductSelect(e) {
    var p = e.promise;
    if (!p || typeof p.then !== 'function') return;
    p.then(function (r) {
      var d = r && r.detail ? r.detail : null;
      if (!d) return;
      var host = document.querySelector('[data-roi-bis-pdp]');
      if (!host) return;
      if (d.productId && String(d.productId) !== String(host.getAttribute('data-product-id'))) return;
      var fresh = d.html && d.html.querySelector ? d.html.querySelector('[data-roi-bis-pdp]') : null;
      if (fresh) {
        host.innerHTML = fresh.innerHTML;
      } else if (d.resource && d.resource.available === false) {
        host.innerHTML = renderFromResource(d.resource, host);
      } else {
        host.innerHTML = '';
      }
      paintDone();
    }).catch(function () {});
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function renderFromResource(res, host) {
    var vt = res.title && res.title !== 'Default Title' ? res.title : '';
    var tpl = host.getAttribute('data-line') || "Sold out in {size}. Leave your email and you'll hear from us the day it's back.";
    var line = vt ? tpl.replace('{size}', vt) : tpl.replace(' in {size}', '');
    return (
      '<p class="roi-bis-pdp__line">' + esc(line) + '</p>' +
      '<button type="button" class="roi-bis-btn" data-roi-bis-open' +
      ' data-variant-id="' + esc(res.id) + '"' +
      ' data-product-title="' + esc(host.getAttribute('data-product-title')) + '"' +
      ' data-variant-title="' + esc(vt) + '"' +
      ' data-product-url="' + esc(host.getAttribute('data-product-url')) + '"' +
      ' data-source="pdp">' + esc(host.getAttribute('data-label') || "Notify me when it's back") + '</button>'
    );
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-roi-bis-open]');
    if (opener) {
      if (opener.classList.contains('is-done')) return;
      open({
        variantId: opener.getAttribute('data-variant-id'),
        productTitle: opener.getAttribute('data-product-title'),
        variantTitle: opener.getAttribute('data-variant-title'),
        productUrl: opener.getAttribute('data-product-url'),
        source: opener.getAttribute('data-source') || 'pdp',
      });
      return;
    }
    if (t.closest('[data-roi-bis-close]')) {
      close();
      return;
    }
    var dlg = dialog();
    if (dlg && t === dlg) close();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-roi-bis-sms-toggle]')) return;
    var form = t.closest('form');
    var row = form ? form.querySelector('[data-roi-bis-smsrow]') : null;
    var phone = form ? form.querySelector('[data-roi-bis-phone]') : null;
    if (row) row.hidden = !t.checked;
    if (phone) {
      phone.required = !!t.checked;
      if (t.checked) setTimeout(function () { phone.focus(); }, 40);
    }
  });

  document.addEventListener('submit', onSubmit);
  document.addEventListener('shopify:product:select', onProductSelect);

  window.roiBisOpen = function (payload) {
    return open(payload);
  };

  // Back from the post: reopen in the done state (or with Shopify's own
  // form error, which the snippet renders when the post was rejected).
  (function resume() {
    var qs = location.search + location.hash;
    var hasErr = !!document.querySelector('[data-roi-bis-liquid-error]');
    if (qs.indexOf('bis=1') < 0 && !hasErr) return;
    var posted = qs.indexOf('customer_posted=true') > -1;
    var last = read(LAST_KEY, null) || {};
    store(LAST_KEY, null);
    try {
      var u = new URL(location.href);
      u.searchParams.delete('bis');
      u.searchParams.delete('customer_posted');
      history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
    if (posted && last.variantId) markDone(last.variantId);
    var state = posted ? 'done' : 'form';
    if (!posted && !hasErr) return;
    var tryOpen = function (n) {
      if (open(last, state)) return;
      if (n > 0) setTimeout(function () { tryOpen(n - 1); }, 150);
    };
    tryOpen(10);
  })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintDone);
  else paintDone();
})();
